// extracted by mini-css-extract-plugin
export var photoCredit = "backgroundSlideshow-module--photoCredit--VGPuz";
export var slide = "backgroundSlideshow-module--slide--eXVsk";
export var slideActive = "backgroundSlideshow-module--slideActive--qTbox";
export var slideImage = "backgroundSlideshow-module--slideImage--rNtvQ";
export var slideImageWrapper = "backgroundSlideshow-module--slideImageWrapper--XGXBm";
export var slideshow = "backgroundSlideshow-module--slideshow--h0Tew";